import React, { useEffect } from 'react';
import { graphql } from 'gatsby';

import { ContentfulLayout } from '../shared/constants/Contentful.constants';
import { ICard } from '../types/shared';
import { ISvgImage } from '../types/shared/shared.types';

import SEO from '../components/utils/SEO';
import { baseTrackPageView, DEQ_PAGE_TYPES } from '../utils/deq';
import { renderBodyItem } from '../utils/generic/renderBodyItem';

import BaseLayout from '../components/layouts/BaseLayout';
import ErrorLayout from '../components/layouts/ErrorLayout';
import { GenericPageProps } from '../components/pages/generic-page/GenericPage.types';

const NotFound = ({ data }: GenericPageProps) => {
  const pageData = data.contentfulPageGeneric;
  const headerData = pageData?.header;

  useEffect(() => {
    baseTrackPageView('404.tsx', DEQ_PAGE_TYPES.error);
  }, []);

  return (
    <BaseLayout layoutType={ContentfulLayout.DEFAULT}>
      <SEO
        title={pageData.metadataTitle}
        description={pageData.metadataDescription.metadataDescription}
        lang={pageData.metadataLocale}
        image={pageData.metadataImage.gatsbyImageData?.images?.fallback?.src}
        noIndex={pageData.metadataNoIndex}
      />
      <ErrorLayout
        title={headerData.title}
        description={headerData.body}
        image={headerData.image as ISvgImage}
        primaryLink={headerData.primaryLink}
      >
        {pageData.body?.map((item, key) =>
          renderBodyItem(
            item as ICard,
            key,
            pageData.pageType || '',
            pageData.tags,
            pageData.slug,
            pageData.parentPage,
            pageData.pageName
          )
        )}
      </ErrorLayout>
    </BaseLayout>
  );
};

export default NotFound;

export const data = graphql`
  query pageNotFound {
    contentfulPageGeneric(
      pageType: { eq: "404-page" }
      isDisabled: { eq: true }
    ) {
      id
      pageName
      pageType
      slug
      ...ParentPageGeneric
      tags {
        id
        name
        value
        type
      }
      metadataDescription {
        metadataDescription
      }
      metadataImage {
        gatsbyImageData(layout: FULL_WIDTH)
      }
      metadataNoIndex
      metadataTitle
      header {
        ...Card
      }
      body {
        ... on ContentfulCompCard {
          ...Card
        }
        ... on ContentfulCompCardWrapper {
          ...CardWrapper
        }
      }
    }
  }
`;
